module.exports = __webpack_public_path__ + "static/media/prospero-aerial-1.4997cf61.jpg";